// removed by extract-text-webpack-plugin
module.exports = {"nffs-code-definitions-container":"nffs-code-definitions-container"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/CodeDefinitions/CodeDefinitions.scss
// module id = 2890
// module chunks = 1